import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import PromptPicker from '../promptPicker';

class Sites extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editSite: false,
            filterBy: {}, sortBy: 'name', sortOrder: 1,
            loading: false
        };
    }
    cancel = () => {
        this.setState({ editSite: false, loading: false, error: '', alias: '', newAlias: '', showDeleteConfirm: false })
    }

    editSite = (site) => e => {
        this.setState({ editSite: true, site: site, loading: false, error: '' })
    }
    add = () => {
        this.setState({
            editSite: true,
            site: {
                "id": generateUniqueId(),
                "Site_Number": null,
                "Site_Name": null,
                "Cross_Street": null,
                "Direction": null,
                "Enabled": true,
                "Intro_Message": {
                    "Prompt": "",
                    "Status": false,
                    "Start": "",
                    "End": ""
                },
                "WrapUp_Message": {
                    "Prompt": "",
                    "Status": false,
                    "Start": "",
                    "End": ""
                },
                "Minimum_Hours_Prior": 0,
                "Maximum_Hours_Prior": 0,
                "Operational_Days": {
                    "Sun": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Mon": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Tue": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Wed": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Thu": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Fri": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    },
                    "Sat": {
                        "Start": "8:00 AM",
                        "End": "5:00 PM",
                        "Active": false
                    }

                }
            },
            loading: false,
            error: ''
        })
    }
    handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        const newValue = type === "checkbox" ? checked : value;

        let error = '';

        if (name === "number" && isNaN(Number(newValue))) {
            error = 'Not a valid Number.';
        }

        if (name === "name") {
            const siteExists = this.props.data.Directory.entries.some(site => site.name === newValue && site.id !== this.state.site.id);
            if (siteExists) {
                error = 'This name already exists in the directory.';
            }
        }

        this.setState({
            site: {
                ...this.state.site,
                [name]: newValue
            },
            error: error
        });
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            site: {
                ...prevState.site,
                [name]: value

            }
        }));
    }
    componentDidMount() {
        // Add the keydown event listener
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        // Remove the keydown event listener when the component is unmounted
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    // Function to handle the Escape key press
    handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            this.cancel();
        }
    };


    handleDayActiveChange = (day) => {
        this.setState(prevState => ({
            site: {
                ...prevState.site,
                Operational_Days: {
                    ...prevState.site.Operational_Days,
                    [day]: {
                        ...prevState.site.Operational_Days[day],
                        Active: !prevState.site.Operational_Days[day].Active
                    }
                }
            }
        }));
    }

    confirmEditSite = () => {
        this.props.ws.send(JSON.stringify({ route: 'editSite', site: this.state.site }))
        this.setState({ editSite: false, loading: true, error: '', site: {}, alias: '', newAlias: '' })
    }
    confirmDeleteSite = () => {
        this.props.ws.send(JSON.stringify({ route: 'deleteSite', site: this.state.site }));
        this.setState({ editSite: false, showDeleteConfirm: false, loading: true, error: '', site: {}, alias: '', newAlias: '' });
    }

    handleDeleteClick = () => {
        this.setState({ showDeleteConfirm: true, editSite: false }); // Show confirmation modal
    }

    handleCancelDelete = () => {
        this.setState({ showDeleteConfirm: false, editSite: true }); // Hide confirmation modal
    }

    intoPromptChange = (e, value) => {
        var site = this.state.site
        site.Intro_Message.prompt = value
        this.setState({ site: site })
    }
    wrapUpPromptChange = (e, value) => {
        var site = this.state.site
        site.WrapUp_Message.prompt = value
        this.setState({ site: site })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }
    checkType = (e) => {
        console.log(e.target.value)
        this.setState({ type: e.target.value })
    }
    Intro_MessageToggle = (field) => {
        var site = this.state.site
        site.Intro_Message[field] = !site.Intro_Message[field]
        this.setState({ site: site })
    }
    WrapUp_MessageToggle = (field) => {
        var site = this.state.site
        site.WrapUp_Message[field] = !site.WrapUp_Message[field]
        this.setState({ site: site })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }

    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                    return false
                }
            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    renderKeypadButton = (key) => {
        console.log(key)
        var isSelected = this.state.site.Operational_Days[key].Active;

        const buttonStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '50px', // Increased button size
            width: '50px', // Increased button size
            borderRadius: '50%', // Circle shape
            backgroundColor: isSelected ? '#339977' : '#f2f2f2',
            color: isSelected ? 'white' : 'black',
            cursor: 'pointer',
            userSelect: 'none',
            margin: '5px', // Optional: for spacing between buttons
        };

        const hoverStyle = {
            backgroundColor: isSelected ? '#3ba481' : '#e0e0e0'
        };

        return (
            <div
                key={key}
                style={buttonStyle}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
                onClick={() => this.handleDayActiveChange(key)}
            >
                {key}
            </div>
        );
    };

    renderKeypad = () => {
        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',];
        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)', // Changed to fit all days in one row
                gap: '5px',
                padding: '5px'
            }}>
                {daysOfWeek.map(day => this.renderKeypadButton(day))}
            </div>
        );
    };


    renderActiveDays = () => {
        const dayOfWeek = {
            Sun: 'Sunday',
            Mon: 'Monday',
            Tue: 'Tuesday',
            Wed: 'Wednesday',
            Thu: 'Thursday',
            Fri: 'Friday',
            Sat: 'Saturday'
        }
        const dayOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const activeDays = [];

        for (var day in this.state.site.Operational_Days) {
            if (this.state.site.Operational_Days[day].Active) {
                activeDays.push(
                    <tr key={day} dayOfWeek={day}>
                        <td style={{
                            fontWeight: 'bold',
                            padding: '10px 20px',
                            fontSize: '16px',
                            fontFamily: 'Arial, sans-serif',
                            minWidth: '100px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                        }}>
                            <span style={{ marginRight: '20px' }}>{dayOfWeek[day]}</span>
                            <div>
                                <span style={{ marginRight: '10px' }}>Start:</span>
                                <Flatpickr
                                    data-enable-time
                                    noCalendar
                                    value={this.state.site.Operational_Days[day].Start}
                                    onChange={([date], dateStr, instance) => {
                                        this.handleTimeChange(dateStr, instance.input.getAttribute('data-dayofweek'), 'Start');
                                    }}
                                    data-dayofweek={day} // Custom attribute for day of the week
                                    options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "h:i K",
                                        time_24hr: false
                                    }}
                                    style={{
                                        paddingRight: '30px',
                                        marginRight: '5px',
                                        padding: '5px',
                                        width: '75px',
                                        fontSize: '16px'
                                    }}
                                />
                                <span style={{ marginRight: '10px', marginLeft: '15px' }}>End:</span>
                                <Flatpickr
                                    data-enable-time
                                    noCalendar
                                    value={this.state.site.Operational_Days[day].End}
                                    onChange={([date], dateStr, instance) => {
                                        this.handleTimeChange(dateStr, instance.input.getAttribute('data-dayofweek'), 'End');
                                    }}
                                    data-dayofweek={day} // Custom attribute for day of the week
                                    options={{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "h:i K",
                                        time_24hr: false
                                    }}
                                    style={{
                                        paddingRight: '30px',
                                        marginRight: '5px',
                                        padding: '5px',
                                        width: '75px',
                                        fontSize: '16px'
                                    }}
                                />
                            </div>
                        </td>
                    </tr>
                );
            }
        }

        // Order the active days by day of the week
        console.log("Sorting active days");
        console.log(activeDays);
        activeDays.sort((a, b) => {
            const dayA = a.props.dayOfWeek;
            const dayB = b.props.dayOfWeek;
            const indexA = dayOrder.indexOf(dayA);
            const indexB = dayOrder.indexOf(dayB);
            console.log(`Sorting: ${dayA} (index ${indexA}) vs ${dayB} (index ${indexB})`);
            return indexA - indexB;
        }); console.log(activeDays);
        if (activeDays.length > 0) {
            return (
                <table style={{
                    width: '100%',
                    textAlign: 'left',
                    borderCollapse: 'collapse'
                }}>
                    <tbody>
                        {activeDays}
                    </tbody>
                </table>
            );
        } else {
            return <div>No Active Days</div>;
        }
    };


    renderHoursPrior = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                fontFamily: 'Arial, sans-serif',
                fontSize: '16px',
                marginTop: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <label style={{
                        marginRight: '10px',
                        fontWeight: 'bold'
                    }}>Minimum Hours Prior:</label>
                    <input
                        type="number"
                        value={this.state.site.Minimum_Hours_Prior}
                        onChange={(e) => this.setState({
                            site: {
                                ...this.state.site,
                                Minimum_Hours_Prior: e.target.value
                            }
                        })}
                        style={{
                            padding: '5px',
                            fontSize: '16px',
                            width: '60px',
                            MozAppearance: 'textfield' // For Firefox
                        }}
                        onKeyDown={(e) => (e.key === 'e' || e.key === '-' || e.key === '+') && e.preventDefault()} // Prevent invalid characters
                    />
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <label style={{
                        marginRight: '10px',
                        fontWeight: 'bold'
                    }}>Maximum Hours Prior:</label>
                    <input
                        type="number"
                        value={this.state.site.Maximum_Hours_Prior}
                        onChange={(e) => this.setState({
                            site: {
                                ...this.state.site,
                                Maximum_Hours_Prior: e.target.value
                            }
                        })}
                        style={{
                            padding: '5px',
                            fontSize: '16px',
                            width: '60px',
                            MozAppearance: 'textfield' // For Firefox
                        }}
                        onKeyDown={(e) => (e.key === 'e' || e.key === '-' || e.key === '+') && e.preventDefault()} // Prevent invalid characters
                    />
                </div>
            </div>
        );
    };
    handleTimeChange = (value, dayOfWeek, timeType) => {
        this.setState(prevState => ({
            site: {
                ...prevState.site,
                Operational_Days: {
                    ...prevState.site.Operational_Days,
                    [dayOfWeek]: {
                        ...prevState.site.Operational_Days[dayOfWeek],
                        [timeType]: value
                    }
                }
            }
        }));
    };

    render() {
        if (this.props.active) {

            var sites = JSON.parse(JSON.stringify(this.props.data.Sites.data));
            var Prompts = JSON.parse(JSON.stringify(this.props.data.Prompts));

            //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                sites = this.filterFunc(sites, this.state.filterBy)
            }
            //Build a an array of prompts from this.props.data.Prompts.prompts it will be an object with name and id 
            //Sorting List
            if (this.state.sortBy !== '') {
                sites.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }




            //Loop through sites 


            var editSite = ""
            if (this.state.editSite) {

                editSite = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop">
                            <div className="viewCloser" onClick={this.cancel}></div>

                            <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr", gridGap: "8px", padding: "1px" }}>
                                <div className="snazzyInputBox">
                                    <input className="textInput" type="text" value={this.state.site.Site_Name} onChange={(e) => this.setState({
                                        site: {
                                            ...this.state.site,
                                            Site_Name: e.target.value
                                        }
                                    })} ></input>
                                    <span className="inputBar"></span>
                                    <label className="textLabel">Street</label>
                                </div>
                                <div className="snazzyInputBox">
                                    <input className="textInput" type="text" value={this.state.site.Cross_Street} onChange={(e) => this.setState({
                                        site: {
                                            ...this.state.site,
                                            Cross_Street: e.target.value
                                        }
                                    })} ></input>
                                    <span className="inputBar"></span>
                                    <label className="textLabel">Cross Street</label>
                                </div>
                                <div className="snazzyInputBox">
                                    <input className="textInput" type="text" value={this.state.site.Direction} onChange={(e) => this.setState({
                                        site: {
                                            ...this.state.site,
                                            Direction: e.target.value
                                        }
                                    })} ></input>
                                    <span className="inputBar"></span>
                                    <label className="textLabel">Direction</label>
                                </div>
                                <div className="snazzyInputBox">
                                    <input className="textInput" type="text" value={this.state.site.Site_Number} onChange={(e) => this.setState({
                                        site: {
                                            ...this.state.site,
                                            Site_Number: e.target.value
                                        }
                                    })} ></input>
                                    <span className="inputBar"></span>
                                    <label className="textLabel">Site Number</label>
                                </div>


                            </div>
                            <div>
                                {this.renderHoursPrior()}
                            </div>
                            {/* Operational Days Keypad*/}
                            <div>
                                {this.renderKeypad()}
                            </div>
                            <br />
                            {/* Day of Week Section */}
                            <div>
                                {this.renderActiveDays()}
                            </div>
                            <br />
                            {/* Intro Message */}
                            <div style={{ backgroundColor: '#F0F0F0', borderRadius: '8px', padding: '20px', margin: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <div style={{ fontWeight: 'bold' }}>Intro Message:</div>
                                    <div className="activeBox" style={{ position: "relative", cursor: "pointer" }} onClick={() => this.Intro_MessageToggle('Status')}>
                                        <div className={this.state.site.Intro_Message.Status ? "enabled" : "disabled"} style={{ position: "absolute", zIndex: 1 }}></div>
                                    </div>
                                </div>
                                {this.state.site.Intro_Message.Status && (
                                    <>
                                        <div style={{ display: 'inline-block', paddingTop: '8px' }}>
                                            <div>Start</div>
                                            <Flatpickr
                                                style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                                options={{ dateFormat: "Y-m-d h:i K" }}
                                                data-enable-time
                                                value={this.state.site.Intro_Message.Start}
                                                onChange={date => {
                                                    date[0] ? this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            Intro_Message: {
                                                                ...prevState.site.Intro_Message,
                                                                Start: date[0]
                                                            }
                                                        }
                                                    })) : this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            Intro_Message: {
                                                                ...prevState.site.Intro_Message,
                                                                Start: undefined
                                                            }
                                                        }
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: 'inline-block' }}>
                                            <div>End</div>
                                            <Flatpickr
                                                style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                                options={{ dateFormat: "Y-m-d h:i K" }}
                                                data-enable-time
                                                value={this.state.site.Intro_Message.End}
                                                onChange={date => {
                                                    date[0] ? this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            Intro_Message: {
                                                                ...prevState.site.Intro_Message,
                                                                End: date[0]
                                                            }
                                                        }
                                                    })) : this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            Intro_Message: {
                                                                ...prevState.site.Intro_Message,
                                                                End: undefined
                                                            }
                                                        }
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <PromptPicker prompts={Prompts} currentPrompt={this.state.site.Intro_Message.prompt} selectionChange={this.intoPromptChange} ws={this.props.ws} />
                                    </>
                                )}
                            </div>
                            {/* Wrap Up Message */}
                            <div style={{ backgroundColor: '#F0F0F0', borderRadius: '8px', padding: '20px', margin: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <div style={{ fontWeight: 'bold' }}>Wrap Up Message:</div>
                                    <div className="activeBox" style={{ position: "relative", cursor: "pointer" }} onClick={() => this.WrapUp_MessageToggle('Status')}>
                                        <div className={this.state.site.WrapUp_Message.Status ? "enabled" : "disabled"} style={{ position: "absolute", zIndex: 1 }}></div>
                                    </div>
                                </div>
                                {this.state.site.WrapUp_Message.Status && (
                                    <>
                                        <div style={{ display: 'inline-block', paddingTop: '8px' }}>
                                            <div>Start</div>
                                            <Flatpickr
                                                style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                                options={{ dateFormat: "Y-m-d h:i K" }}
                                                data-enable-time
                                                value={this.state.site.WrapUp_Message.Start}
                                                onChange={date => {
                                                    date[0] ? this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            WrapUp_Message: {
                                                                ...prevState.site.WrapUp_Message,
                                                                Start: date[0]
                                                            }
                                                        }
                                                    })) : this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            WrapUp_Message: {
                                                                ...prevState.site.WrapUp_Message,
                                                                Start: undefined
                                                            }
                                                        }
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: 'inline-block' }}>
                                            <div>End</div>
                                            <Flatpickr
                                                style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                                options={{ dateFormat: "Y-m-d h:i K" }}
                                                data-enable-time
                                                value={this.state.site.WrapUp_Message.End}
                                                onChange={date => {
                                                    date[0] ? this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            WrapUp_Message: {
                                                                ...prevState.site.WrapUp_Message,
                                                                End: date[0]
                                                            }
                                                        }
                                                    })) : this.setState(prevState => ({
                                                        site: {
                                                            ...prevState.site,
                                                            WrapUp_Message: {
                                                                ...prevState.site.WrapUp_Message,
                                                                End: undefined
                                                            }
                                                        }
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <PromptPicker prompts={Prompts} currentPrompt={this.state.site.WrapUp_Message.prompt} selectionChange={this.wrapUpPromptChange} ws={this.props.ws} />
                                    </>
                                )}
                            </div>
                            {/* Error Message */}
                            <div className="error">{this.state.error}</div>
                            {/* Confirm and Delete Buttons */}
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="button confirm" onClick={this.confirmEditSite} title="Confirm Changes">Confirm</div>
                                <div className="button delete" onClick={this.handleDeleteClick} style={{ backgroundColor: '#c0392b' }} title="Delete Site">Delete</div>
                            </div>
                        </div>
                    </div>
                );
            }
            var deleteConfirmation = ""
            if (this.state.showDeleteConfirm) {

                var siteNumber = this.state.site.Site_Number

                deleteConfirmation = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" >
                            <div className="viewCloser" onClick={this.handleCancelDelete}></div>
                            {(siteNumber) ? <div>Delete Site: {siteNumber}</div> : <div>Delete Site</div>}
                            <br />
                            <div>Are you sure you want to delete this site?</div>
                            <div><strong>This action cannot be undone.</strong></div> {/* Made the text bold */}
                            <br />
                            <div className="button" style={{ backgroundColor: '#c0392b' }} onClick={this.confirmDeleteSite}>Delete</div>
                            <br />
                            <div className="button" onClick={this.handleCancelDelete}>Cancel</div>
                        </div>
                    </div>
                )
            }

            var siteList = []
            var tableHeaders = ""
            tableHeaders = (<tr className="dataRow">
                <th style={{ minWidth: '100px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("Site_Number")}>Number {this.filterIcon("Site_Number")}</th>
                <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("Site_Name")}>Street {this.filterIcon("Site_Name")}</th>
                <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("Cross_Street")}>Cross Street {this.filterIcon("Cross_Street")}</th>
                <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("Direction")}>Direction {this.filterIcon("Direction")}</th>
                <th style={{ minWidth: '100px', maxWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("Enabled")}>Enabled {this.filterIcon("Enabled")}</th>
            </tr>)
            for (var site of sites) {
                siteList.push(
                    <tr className="dataRow" onClick={this.editSite(JSON.parse(JSON.stringify(site)))} key={site.id}>
                        <td style={{ minWidth: '100px', textAlign: 'left' }}>{site.Site_Number}</td>
                        <td style={{ minWidth: '150px', textAlign: 'left' }}>{site.Site_Name}</td>
                        <td style={{ minWidth: '150px', textAlign: ' left' }}>{site.Cross_Street}</td>
                        <td style={{ minWidth: '150px', textAlign: 'left' }}>{site.Direction}</td>
                        <td style={{ minWidth: '100px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{site.Enabled ?
                            <div style={{
                                backgroundColor: '#2A6AA9',
                                color: 'white',
                                borderRadius: '50%',
                                height: '20px',
                                width: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <svg width="10" height="8" viewBox="0 0 10 8">
                                    <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
                                </svg>
                            </div>
                            : null
                        }</td>
                    </tr>
                );
            }

            var addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a User" onClick={this.add} />

            return (
                <div width="100%">
                    {addButton}
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '280px', marginRight: '10px' }}>
                            <div className="filterBox">
                                <h4>Filter By:</h4>
                                <div>
                                    <label>Site Number:</label>
                                    <input type="text" onChange={this.filter("Site_Number")} value={this.state.filterBy.department} style={{ width: '120px' }} />
                                </div>
                                <div>
                                    <label>Street:</label>
                                    <input type="text" onChange={this.filter("Site_Name")} value={this.state.filterBy.name} />
                                </div>
                                <div>
                                    <label>Cross Street:</label>
                                    <input type="text" onChange={this.filter("Cross_Street")} value={this.state.filterBy.Cross_Street} />
                                </div>
                                <div>
                                    <label>Direction:</label>
                                    <input type="text" onChange={this.filter("Direction")} value={this.state.filterBy.Direction} />
                                </div>
                                <div>
                                    <label>Enabled:</label>
                                    <select onChange={this.filter("Enabled")} value={this.state.filterBy.Enabled} style={{ width: '120px' }}>
                                        <option value="">All</option>
                                        <option value="true">Enabled</option>
                                        <option value="false">Disabled</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table>
                                <thead>
                                    {tableHeaders}
                                </thead>
                                <tbody>
                                    {siteList}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {deleteConfirmation}
                    {editSite}
                </div>
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

const icon = "menuStar"
const roles = ["View"]
export { Sites, icon, roles }




function generateUniqueId() {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).slice(2);
    const uniqueId = timestamp + randomStr;
    return uniqueId;
}